
    import '/opt/buildhome/repo/components/useXChat/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["components-use-x-chat-demo-basic","components-use-x-chat-demo-stream","components-use-x-chat-demo-suggestions"],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/opt/buildhome/repo/components/useXChat/index.en-US.md?type=demo')
};